import { Action, createReducer, on } from '@ngrx/store';

import * as AuthenticationActions from './authentication.actions';

export const AUTHENTICATION_FEATURE_KEY = 'authentication';

export interface State {
  hasAccessToken: boolean;
  isAuthenticated: boolean;
  user: any | null;
  errorMessage: string | null;
  expirationDate?: Date;
}

export const initialState: State = {
  hasAccessToken: false,
  isAuthenticated: false,
  user: null,
  errorMessage: null,
  expirationDate: undefined
};

const authenticationReducer = createReducer(
  initialState,
  on(AuthenticationActions.accessTokenReceived, (state, {expiresAt}) => ({
    ...state,
    hasAccessToken: true,
    expirationDate: new Date(expiresAt),
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return authenticationReducer(state, action);
}
